import _ from "lodash";

import ObjectUtil from "../../../../../react/core/utils/ObjectUtil";

const HeaderPlanMessagingDelegate = function ($q, $window, MessagingFactory) {
    const throttledMessagesListQuery = _.throttle(MessagingFactory.messagesList.query, 1000, {
        trailing: true
    });

    const getMessagesListSuccess = function (res) {
        let list = res.data;

        if (ObjectUtil.isUndefinedOrNull(list)) {
            return [];
        }

        if (list.hasOwnProperty("slides")) {
            list = res.data.slides;
        }

        const slides = _._(list)
            .sortBy((message) => {
                const subjectTypeSortOrder = ["PA", "GA", "ACC", "GEN"];
                return _.indexOf(subjectTypeSortOrder, message.subjectType);
            })
            .filter((message) => {
                return message;
            })
            .map((m, index) => {
                const navigable = _.includes(_.get(m, "information"), "apple-k");

                return _.extend(m, {
                    expand: false,
                    appleHtml: _.includes(_.get(m, "planName"), "Apple"),
                    active: index === 0,
                    navigable: navigable,
                    onClick: navigable
                        ? function () {
                              const account = accountService.getActiveGroupAccount();
                              window.location.href = [
                                  LegacyService.getCurrentDomain(),
                                  "participant/accounts/",
                                  "#/account/",
                                  account.individualId,
                                  "/",
                                  account.groupId,
                                  "/contribution"
                              ].join("");
                          }
                        : _.noop
                });
            })
            .value();

        return slides;
    };

    const getMessagesListFault = function (err) {
        return $q.reject(err);
    };

    const getMessagesList = function () {
        return throttledMessagesListQuery({}, getMessagesListSuccess, getMessagesListFault)
            .$promise;
    };

    return {
        getMessagesList: getMessagesList
    };
};

HeaderPlanMessagingDelegate.$inject = ["$q", "$window", "MessagingFactory"];
export default HeaderPlanMessagingDelegate;
